var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-file"
  }, [_vm.row ? _c('b-modal', {
    attrs: {
      "id": "repRejectModal",
      "centered": "",
      "size": "md",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "repRejectModal-header text-center"
        }, [_c('h4', [_vm._v("Reject Request")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }], null, false, 3734142198)
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "repRejectModal-form"
  }, [_c('div', {
    staticClass: "d-flex repApproveModal-form"
  }, [_c('div', {
    staticClass: "exclaim-bg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/exclaim.svg")
    }
  })]), _c('div', {}, [_c('div', {
    staticClass: "note-txt"
  }, [_vm._v(" Please note that this charge of "), _c('b', [_vm._v("$5.00")]), _vm._v(" will "), _c('b', [_vm._v("NOT be applied ")]), _vm._v(" to this member card as the transaction has been rejected ")]), _c('div', {
    staticClass: "note-txt"
  }, [_vm._v(" Do you want to really "), _c('b', [_vm._v("Reject")]), _vm._v(" the request? "), _c('br'), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.admin_reason,
      expression: "form.admin_reason"
    }],
    staticClass: "form-control mt-2",
    attrs: {
      "rules": {
        required: true
      },
      "labelFor": "reason",
      "labelName": "Reason",
      "inputName": "reason",
      "formGroupClass": "form-group mb-3",
      "placeholder": "Enter Reason",
      "rows": "4"
    },
    domProps: {
      "value": _vm.form.admin_reason
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "admin_reason", $event.target.value);
      }
    }
  })])])]), _c('div', {
    staticClass: "d-flex align-items-center justify-content-end gap-2 mt-4"
  }, [_c('button', {
    staticClass: "cancel-btn request-cancel m-0",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _c('button', {
    staticClass: "approve-btn univ-btn m-0",
    on: {
      "click": _vm.rejectRequest
    }
  }, [_vm._v("Yes Reject")])])])])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }